import { render, staticRenderFns } from "./ui-checkbox.vue?vue&type=template&id=1e84c842&"
import script from "./ui-checkbox.vue?vue&type=script&lang=js&"
export * from "./ui-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports